module.exports = __webpack_public_path__ + "static/media/Manulife_rgb.fec65786.svg";